import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
  baseURL: (import.meta.env.VITE_API_URL as string) || window.location.origin,
  plugins: [emailOTPClient()],
});
